// extracted by mini-css-extract-plugin
module.exports = {"theme":"ModalWithTheme_theme__1Jfkl"};